import defaultConfig from '../config.js';

// Module namespace
// const mpro = window.mpro || {};

// Add the config object
Object.defineProperty(mpro, 'config', {
	get: () => defaultConfig,
	set: (obj) => {
		for (const type in obj) {
			if (Object.hasOwn(obj, type)) {
				// Merge entries
				defaultConfig[type] = mergeConfigEntry(type, [type], defaultConfig[type], obj[type]);
			}
		}
	},
});

/**
 * Convert a string object path to a literal object
 *
 * @param {string|string[]} name
 * @param {*} value
 * @param {*} _current
 * @param {*} _main
 */
const pathToObject = (name, value, _current = null, _main = null) => {

	// Initial path
	if (typeof name === 'string') {
		return pathToObject(name.split('.'), value, null, {});
	}

	// Get current entry
	const entry = name.shift();

	if (!entry) {
		console.warn('Invalid setConfig object entry for: %o', name);
		return;
	}

	// Initial entry
	if (!_current) {
		_current = _main;
	}

	// Still have more entries
	if (name.length > 0) {
		const _next = _current[entry] = {};
		return pathToObject(name, value, _next, _main);
	}

	// Last entry - add the value
	_current[entry] = value;

	return _main;
};

/**
 * Merge new config data
 *
 * @param {string} name
 * @param {string[]} path
 * @param {*} orig
 * @param {*} target
 */
const mergeConfigEntry = (name, path, orig, target) => {

	// Add entire target for paths that do not exist in the original object
	if (orig == null) {
		return target;
	}

	if (target == null) {
		// Allow to nullify deep config props
		if (path.length > 3) {
			return target;
		}
		// Don't change props on this level

		return orig;

	}

	const origType = typeof orig;

	// Plain object
	if (origType === 'object' && !Array.isArray(orig)) {
		// Also plain object
		if ((typeof target === 'object') && !Array.isArray(target)) {
			for (const s in target) {
				if (Object.hasOwn(target, s)) {
					orig[s] = mergeConfigEntry(name, [...path, s], orig[s], target[s]);
				}
			}
		}
		// Different type of target
		else {
			console.warn('Cannot replace %s config entry key %o with %o', name, path.join('.'), target);
		}
		return orig;
	}
	// Array or something else

	// Overwrite is target is of same type
	if (origType === typeof target) {
		return target;
	}
	console.warn('Cannot replace %s config entry key %o with %o', name, path.join('.'), target);
	return orig;

};

/**
 * Alias for the mpro.push method that allows for setting string object paths
 *
 * @param {string} name
 * @param {*} value
 */
mpro.setConfig = (name, value) => {

	if (!name) {
		console.warn('Invalid setConfig name: %o (with value: %o)', name, value);
		return;
	}

	// String object path
	if (typeof name === 'string') {
		const obj = pathToObject(name, value);
		mpro.config = obj;
	}
	// Assume it's a plain object (should fail in the config setter if it's not)
	else {
		mpro.config = name;
	}
};

/**
 * Initialize the global config object
 *
 * @param {*} tempObj
 */
mpro.initConfig = (tempObj) => {

	const tempConfig = tempObj.config;
	// let newConfig = { ...defaultConfig };
	delete tempObj.config;

	if (!tempConfig) {
		return;
	}

	// Merge with default config
	mpro.config = tempConfig;
};

export default mpro;
